module.exports = __webpack_public_path__ + "img/slightly-smile.69f12b28.png";